/**
* @file 资源管理-司机资源-创建/修改司机信息
* */
<template>
    <div class="dz-create">
        <h3>{{ title }}</h3>
        <el-form :model="form" :rules="rules" ref="form" label-width="130px" label-position="right" :validate-on-rule-change="false">
            <div class="formTitle">
                <span>个人信息</span>
            </div>
            <div class="table-container">
                <el-row :gutter="0" class="table-row">
                    <el-col :span="12" class="table-cell">
                        <el-form-item label="机构名称" prop="organizationId">
                            <el-select v-model="form.organizationId" filterable :disabled="!!id"
                                v-if="mixinUserInfo?.organizationType === 1">
                                <el-option v-for="(item, i) in organizations" :key="i" :value="item.id"
                                    :label="item.name">
                                </el-option>
                            </el-select>
                            <span v-else>{{
                                organizations && organizations[0] && organizations[0].name
                            }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="table-cell">
                        <el-form-item label="所属公司" prop="companyName">
                            <el-input v-model="form.companyName" placeholder="请输入" :maxlength="30"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="0" class="table-row">
                    <el-col :span="12" class="table-cell">
                        <el-form-item label="司机姓名" prop="name">
                            <el-input v-model="form.name" placeholder="请输入" maxlength="10" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="table-cell">
                        <el-form-item label="手机号码" prop="phone">
                            <el-input v-model="form.phone" placeholder="请输入" maxlength="11" show-word-limit>
                                <template slot="prepend">+86</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="0" class="table-row">
                    <el-col :span="12" class="table-cell">
                        <el-form-item label="身份证号" prop="idCard">
                            <el-input v-model="form.idCard" placeholder="请输入" maxlength="18" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="table-cell">
                        <el-form-item label="登录密码" prop="password">
                            <el-input v-model="form.password" type="password" placeholder="请输入"
                                show-password></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="0" class="table-row">
                    <el-col :span="12" class="table-cell">
                        <el-form-item label="司机性别" prop="gender">
                            <el-input v-model="form.gender" placeholder="请输入" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="table-cell">
                        <el-form-item label="重复密码" prop="confirmPassword">
                            <el-input v-model="form.confirmPassword" type="password" placeholder="请输入"
                                show-password></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="0" class="table-row">
                    <el-col :span="12" class="table-cell">
                        <el-form-item label="身份证有效期" prop="idCardValidType">
                            <el-radio-group v-model="form.idCardValidType">
                                <el-radio :label="1">短期有效</el-radio>
                                <el-radio :label="2">长期有效</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="table-cell">
                        <el-form-item label="证件有效期至" prop="idCardValid" v-if="form.idCardValidType === 1">
                            <el-date-picker v-model="form.idCardValid" type="date" placeholder="请选择">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="证件有效期至" prop="idCardValid" v-else>
                            <el-date-picker v-model="form.idCardValid" type="date" placeholder="请选择" disabled>
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="0" class="table-row">
                    <el-col :span="12" class="table-cell">
                        <el-form-item label="身份证人像面" prop="idCardFrontPath">
                            <up-img :file.sync="form.idCardFrontPath" width="150" height="80" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="table-cell">
                        <el-form-item label="身份证国徽面" prop="idCardBackPath">
                            <up-img :file.sync="form.idCardBackPath" width="150" height="80" />
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="0" class="table-row">
                    <el-col :span="24" class="table-cell">
                        <el-form-item label="司机头像" prop="headPortrait">
                            <up-img :file.sync="form.headPortrait" :width="80" :height="80" />
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
            <div class="formTitle">
                <span>证件信息</span>
            </div>
            <div class="table-container">
                <el-row :gutter="0" class="table-row">
                    <el-col :span="12" class="table-cell">
                        <el-form-item label="准驾车型" prop="driverClass">
                            <el-select v-model="form.driverClass" placeholder="请选择">
                                <el-option v-for="item in $const.DRIVERSHORTTYPE" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="table-cell">
                        <el-form-item label="初次领证日期" prop="firstIssueDate">
                            <el-date-picker v-model="form.firstIssueDate" type="date" placeholder="请选择">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="0" class="table-row">
                    <el-col :span="12" class="table-cell">
                        <el-form-item label="驾驶证有效期" prop="driverLicenseValidType">
                            <el-radio-group v-model="form.driverLicenseValidType">
                                <el-radio :label="1">短期有效</el-radio>
                                <el-radio :label="2">长期有效</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="table-cell">
                        <el-form-item label="证件有效期至" prop="driverLicenceValid" v-if="form.driverLicenseValidType === 1">
                            <el-date-picker v-model="form.driverLicenceValid" type="date" placeholder="请选择">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="证件有效期至" prop="driverLicenceValid" v-else>
                            <el-date-picker v-model="form.driverLicenceValid" type="date" placeholder="请选择" disabled>
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="0" class="table-row">
                    <el-col :span="12" class="table-cell">
                        <el-form-item label="驾驶证正页" prop="driverLicensePath">
                            <up-img :file.sync="form.driverLicensePath" width="150" height="80" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="table-cell">
                        <el-form-item label="驾驶证副页" prop="driverLicenseBackPath">
                            <up-img :file.sync="form.driverLicenseBackPath" width="150" height="80" />
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="0" class="table-row">
                    <el-col :span="24" class="table-cell">
                        <el-form-item label="从业资格证" prop="qualificationsPath">
                            <up-img :file.sync="form.qualificationsPath" width="150" height="80" />
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
            <div class="formTitle">
                <span>其他信息</span>
            </div>
            <div class="table-container">
                <el-row :gutter="0" class="table-row">
                    <el-col :span="12" class="table-cell">
                        <el-form-item label="紧急联系人姓名" prop="emergency">
                            <el-input v-model="form.emergency" placeholder="请输入" maxlength="10"
                                show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="table-cell">
                        <el-form-item label="紧急联系人电话" prop="emergencyPhone">
                            <el-input v-model="form.emergencyPhone" placeholder="请输入" maxlength="11" show-word-limit>
                                <template slot="prepend">+86</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
        </el-form>

        <div style="margin-top: 32px;">
            <el-button @click="cancel">取消</el-button>
            <el-button type="primary" @click="submitForm" :loading="loading">保存</el-button>
        </div>
    </div>
</template>

<script>
import upImg from "@/components/upImg";

export default {
    name: "dzCreate",
    components: {
        upImg
    },
    props: {
        id: {
            type: [String, Number],
            default: ""
        },
        title: {
            type: String,
            default: "新增司机"
        }
    },
    data() {
        return {
            loading: false,
            form: {
                organizationId: "",
                companyName: "",
                name: "",
                phone: "",
                idCard: "",
                password: "",
                confirmPassword: "",
                gender: "",
                idCardValidType: 1,
                idCardValid: "",
                idCardFrontPath: "",
                idCardBackPath: "",
                headPortrait: "",
                driverClass: "",
                firstIssueDate: "",
                driverLicenseValidType: 1,
                driverLicenceValid: "",
                driverLicensePath: "",
                driverLicenseBackPath: "",
                qualificationsPath: "",
                emergency: "",
                emergencyPhone: ""
            },

            organizationOptions: [],
            driverTypeOptions: [
                { value: "A1", label: "A1" },
                { value: "A2", label: "A2" },
                { value: "A3", label: "A3" },
                { value: "B1", label: "B1" },
                { value: "B2", label: "B2" },
                { value: "C1", label: "C1" },
                { value: "C2", label: "C2" }
            ]
        };
    },
    async created() {
        await this.mixinOrganizations();
        if (this.mixinUserInfo?.organizationType === 2 && this.organizations?.[0]?.id) {
            this.$set(this.form, "organizationId", this.organizations[0].id);
        }
        // 判断是否开启司机信息识别
        let IdentifySwitchURL = "/api/v1/manage/driver/queryIsOcr";
        let res = await this.$axios.get(IdentifySwitchURL);
        if (res && res.code === 1) {
            this.idCardIF = res.data;
        }
        if (this.id) {
            this.getDriverInfo();
        }
    },
    computed: {
        rules() {
            return {
                organizationId: [
                    { required: true, message: "请选择机构名称", trigger: "change" }
                ],
                name: [
                    { required: true, message: "请输入司机姓名", trigger: "blur" }
                ],
                phone: [
                    { required: true, message: "请输入手机号码", trigger: "blur" },
                    { pattern: /^1[3-9]\d{9}$/, message: "请输入正确的手机号码", trigger: "blur" }
                ],
                idCard: [
                    { required: true, message: "请输入身份证号", trigger: "blur" },
                    {
                        pattern: /(^\d{15}$)|(^\d{17}(\d|X|x)$)/,
                        message: "请输入正确的身份证号",
                        trigger: "blur"
                    },
                    {
                        validator: (rule, value, callback) => {
                            if (!value) {
                                callback();
                                return;
                            }

                            // 15位身份证校验
                            if (value.length === 15) {
                                callback();
                                return;
                            }

                            // 18位身份证校验：验证出生日期
                            if (value.length === 18) {
                                const year = value.substring(6, 10);
                                const month = value.substring(10, 12);
                                const day = value.substring(12, 14);

                                const date = new Date(`${year}-${month}-${day}`);
                                const now = new Date();

                                if (
                                    date.getFullYear() !== parseInt(year) ||
                                    date.getMonth() + 1 !== parseInt(month) ||
                                    date.getDate() !== parseInt(day) ||
                                    date > now ||
                                    parseInt(year) < 1900
                                ) {
                                    callback(new Error("身份证号中的出生日期无效"));
                                    return;
                                }
                            }

                            callback();
                        },
                        trigger: "blur"
                    }
                ],
                idCardValidType: [
                    { required: true, message: "请选择身份证有效期类型", trigger: "change" }
                ],
                idCardValid: [
                    { required: true, message: "请选择证件有效期", trigger: "change" }
                ],
                idCardFrontPath: [
                    { required: true, message: "请上传身份证人像面照片", trigger: "change" }
                ],
                idCardBackPath: [
                    { required: true, message: "请上传身份证国徽面照片", trigger: "change" }
                ],
                driverClass: [
                    { required: true, message: "请选择准驾车型", trigger: "change" }
                ],
                firstIssueDate: [
                    { required: true, message: "请选择初次领证日期", trigger: "change" }
                ],
                driverLicenseValidType: [
                    { required: true, message: "请选择驾驶证有效期类型", trigger: "change" }
                ],
                driverLicenceValid: [
                    { required: true, message: "请选择证件有效期", trigger: "change" }
                ],
                driverLicensePath: [
                    { required: true, message: "请上传驾驶证正页照片", trigger: "change" }
                ],
                driverLicenseBackPath: [
                    { required: true, message: "请上传驾驶证副页照片", trigger: "change" }
                ],
                qualificationsPath: [
                    { required: true, message: "请上传从业资格证照片", trigger: "change" }
                ],
                emergency: [
                    { required: false, message: "请输入紧急联系人姓名", trigger: "blur" }
                ],
                emergencyPhone: [
                    {
                        validator: (rule, value, callback) => {
                            if (!value) {
                                callback();
                            } else if (!/^1[3-9]\d{9}$/.test(value)) {
                                callback(new Error("请输入正确的手机号码格式"));
                            } else {
                                callback();
                            }
                        },
                        trigger: "blur"
                    }
                ],
                password: [
                    { required: this.id ? false : true, message: '请输入登录密码', trigger: 'submit' },
                    {
                        validator: (rule, value, callback) => {
                            if (value && value.length < 6) {
                                callback(new Error('密码长度不能少于6位'));
                            } else {
                                callback();
                            }
                        }, 
                        trigger: 'blur' 
                    }
                ],
                confirmPassword: [
                    { required: this.form.password ? true : false, message: '请再次输入密码', trigger: 'submit' },
                    {
                        validator: (rule, value, callback) => {
                           if (value !== this.form.password) {
                                callback(new Error('两次输入密码不一致'));
                            } else {
                                callback();
                            }
                        }, 
                        trigger: 'blur' 
                    }
                ]
            }
        }
    },
    watch: {
        'form.idCardValidType'(newVal) {
            if (newVal === 2) { // 长期有效
                this.form.idCardValid = new Date('2099-12-31 00:00:00');
            } else if (newVal === 1) { // 短期有效
                this.form.idCardValid = '';
            }
        },
        'form.driverLicenseValidType'(newVal) {
            if (newVal === 2) { // 长期有效
                this.form.driverLicenceValid = new Date('2099-12-31 00:00:00');
            } else if (newVal === 1) { // 短期有效
                this.form.driverLicenceValid = '';
            }
        },
        'form.idCard'(newVal) {
            if (newVal && newVal.length >= 17) {
                // 身份证号码第17位：奇数为男，偶数为女
                const sexCode = parseInt(newVal.charAt(16), 10);
                this.form.gender = sexCode % 2 === 1 ? '男' : '女';
            } else {
                this.form.gender = '';
            }
        }
    },
    methods: {
        // 获取司机详情
        async getDriverInfo() {
            if (!this.id) {
                return false;
            } else {
                this.flag = false;
            }

            let url = "/api/v1/manage/driver/" + this.id;
            let { code, data } = await this.$axios.get(url);
            if (code === 1) {
                // 将日期类型转换为13位时间戳
                const dateFields = ['idCardValid', 'firstIssueDate', 'driverLicenceValid'];
                dateFields.forEach(field => {
                    if (data[field]) {
                        // 转换为13位时间戳（毫秒）
                        data[field] = data[field] * 1000;
                    }
                    console.log('field',field, data[field])
                });
                data.idCardValidType = data.idCardValid == 4102329600000 ? 2 : 1;
                data.driverLicenseValidType = data.driverLicenceValid == 4102329600000 ? 2 : 1;

                Object.keys(this.form).forEach(key => {
                    this.form[key] = data[key];
                });
            }
        },
        /**
         * 取消表单提交
         */
        cancel() {
            this.$refs.form.resetFields();
            this.form = {
                organizationId: "",
                companyName: "",
                name: "",
                phone: "",
                idCard: "",
                password: "",
                confirmPassword: "",
                gender: "",
                idCardValidType: 1,
                idCardValid: "",
                idCardFrontPath: "",
                idCardBackPath: "",
                headPortrait: "",
                driverClass: "",
                firstIssueDate: "",
                driverLicenseValidType: 1,
                driverLicenceValid: "",
                driverLicensePath: "",
                driverLicenseBackPath: "",
                qualificationsPath: "",
                emergency: "",
                emergencyPhone: ""
            }
            this.$emit('cancel')
        },

        /**
         * 提交表单
         */
        submitForm() {
            console.log('this.form', this.form)

            this.$refs.form.validate(valid1 => {
                if (valid1) {
                    this.saveData();
                }
            });
        },

        /**
         * 保存表单数据
         */
        async saveData() {
            this.loading = true;

            // 创建表单数据副本，处理日期类型
            const formData = JSON.parse(JSON.stringify(this.form));

            // 将日期类型转换为10位时间戳
            const dateFields = ['idCardValid', 'firstIssueDate', 'driverLicenceValid'];
            dateFields.forEach(field => {
                if (formData[field]) {
                    formData[field] = Math.floor(new Date(formData[field]).getTime() / 1000);
                } 
                console.log('field',field, formData[field])
            });

            // 去除空值字段
            Object.keys(formData).forEach(key => {
                const value = formData[key];
                // 检查各种空值情况：null、undefined、空字符串、空数组、空对象
                if (value === null || value === undefined || value === '') {
                    delete formData[key];
                } else if (Array.isArray(value) && value.length === 0) {
                    delete formData[key];
                } else if (typeof value === 'object' && !Array.isArray(value) &&
                    Object.keys(value).length === 0) {
                    delete formData[key];
                }
            });
            if (formData.password) {
                formData.password = this.$utils.sha256Fn(formData.password);
            }
            formData.gender = formData.gender === '男' ? 1 : 2;
            if(this.id) {
                formData.id = this.id;
            }

            const url = '/api/v1/manage/driver';
            const method = this.id ? 'put' : 'post';


            let { code, data } = await this.$axios[method](url, formData);
            if (code === 1) {
                this.$message.success("保存成功！");
                this.cancel()
                this.$emit('success')
            }
            this.loading = false;
        }
    }
};
</script>

<style lang="less" scoped>
.dz-create {

    .formTitle {
        font-size: 16px;
        font-weight: bold;
        margin: 20px 0 10px;
    }

    .table-container {
        border: 1px solid #EBEEF5;
        border-bottom: none;
        border-radius: 8px;
        overflow: hidden;
    }

    .table-row {
        margin: 0;

        &:last-child {
            .table-cell {
                border-bottom: 1px solid #EBEEF5;
            }
        }
    }

    .table-cell {
        border-bottom: 1px solid #EBEEF5;
        border-right: 1px solid #EBEEF5;
        padding: 0;
        margin: 0;

        &:last-child {
            border-right: none;
        }
    }

    ::v-deep .el-form {
        margin-top: 0;

    }

    ::v-deep .el-form-item {
        display: flex;
        margin-bottom: 0;

        .el-form-item__label {
            padding: 8px 12px;
            box-sizing: border-box;
            border-right: 1px solid #EBEEF5;
            background: #FBFBFB;
            height: auto;
            margin: 0;
            float: none;
            text-align: left;
            color: #909399;
            font-weight: normal;
        }

        .el-form-item__content {
            flex: 1;
            padding: 8px 12px 0;
            box-sizing: border-box;
            margin-left: 0 !important;
            border: none;
            margin-bottom: 16px;
        }
    }
}
</style>
